// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 957 ? "views-app" : chunkId) + "." + {"453":"68693753","660":"cebe855f","957":"8e26d2b0"}[chunkId] + ".chunk.js";
};